import './parallax-img';



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/parallax-img/index.js